export const getCycleBaselineLabel = isBelowBaseline => {
	return isBelowBaseline ? "Abaixo da baseline" : "Acima da baseline";
};

export const getCycleBaselineClassName = isBelowBaseline => {
	return [
		"dashboard-cycle-panel__baseline-value",
		isBelowBaseline
			? "dashboard-cycle-panel__baseline-value--danger"
			: "dashboard-cycle-panel__baseline-value--success"
	].join(" ");
};

export const getGoalLabel = isReached => {
	return isReached ? "Alcançada" : "Não alcançada";
};

export const getGoalClassName = isReached => {
	return [
		"dashboard-cycle-panel__badge",
		isReached
			? "dashboard-cycle-panel__badge--success"
			: "dashboard-cycle-panel__badge--danger"
	].join(" ");
};